<details-card [title]="title" [description]="description">
  <div actions>
    <button
      *ngIf="hasProductScopedWords && !hasNoWords && !allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="hasErrors || isApiRequestInProgress()"
      (click)="onResetToProductDefault()"
    >
      Reset to product default
    </button>
    <button
      *ngIf="!hasNoWords && allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="isApiRequestInProgress()"
      (click)="onDetachFromProductDefault()"
    >
      Detach from product default
    </button>
    <button
      *ngIf="!allWordsHaveProductScope"
      qai-link
      [disabled]="hasErrors || hasNoWords || isApiRequestInProgress()"
      class="header-action"
      (click)="saveAsProductDefault()"
    >
      Save as product default
    </button>
  </div>
  <div
    content
    class="content-container"
    *ngIf="replaceWordsPairedFieldsControl"
  >
    <qai-paired-fields
      [formControl]="replaceWordsPairedFieldsControl"
      [fromLabel]="fromLabel"
      [toLabel]="toLabel"
      [addFromText]="addFromText"
      [addNewPairText]="addNewPairText"
      [getError]="getFieldError"
      [actionsDisabled]="hasErrors"
      (pairRemoved)="onPairRemoved($event)"
    ></qai-paired-fields>
  </div>
</details-card>

<save-as-product-default-modal
  [open]="saveAsProductDefaultModalOpen"
  [moduleUuid]="moduleUuid"
  [keywordTitle]="keywordTitle"
  [networkRequestInProgress]="networkRequestInProgress"
  (confirm)="onSaveAsProductDefaultConfirm()"
  (closeModal)="onSaveAsProductDefaultModalClose()"
  (openChange)="saveAsProductDefaultModalOpen = $event"
></save-as-product-default-modal>
